import Selection from '@simonwep/selection-js';
import * as _ from 'lodash';

import { AppConstants } from '../../app.constants';
import { Selectiontype } from '../enums/selection-type.enum';
import { MonitorKey } from '../models/view-models/monitor-models/monitor-key.type';
import { MainContentComponent } from '../../components/area-main-content/main-content.component';

export function createSelection(
  thisRef: any,
  itemWhichCanBeSelected: string[],
  mappingFunction: Function,
  className: string = AppConstants.SELECTION_CLASS_NAME,
  areaClassName: string = AppConstants.SELECTION_AREA_CLASS_NAME,
  boundaryClassName?: string
) {
  return Selection.create({
    class: className,
    startareas: [`.${areaClassName}`],
    boundaries: [`.${boundaryClassName || areaClassName}`],
    selectionAreaContainer: `.${areaClassName}`,
    startThreshold: 40,
    disableTouch: true,
    singleClick: false,
    selectables: itemWhichCanBeSelected
  })
    .on('move', (data) => {
      const currentSelection: readonly Element[] = data.selected;
      if (currentSelection && currentSelection.length) {
        const isDataTypeIsPdfElements: boolean = _.every(currentSelection, (element: HTMLElement) =>
          element.dataset[AppConstants.SELECTION_TYPE_ATTRIBUTE] === Selectiontype.IdItem);

        if (isDataTypeIsPdfElements) {
          thisRef.selectedItems = currentSelection
            .filter((x) => x && x.id)
            .map((x) => x.id);
        } else {
          thisRef.selectedItems = currentSelection
            .filter((x) => x && x.id && x.id.includes(AppConstants.FULL_MONITOR_KEY_DELIMITER))
            .map((x) => {
              const monitorKey = x.id.split(':');
              return new MonitorKey(monitorKey[1], monitorKey[0]);
            });
        }
      } else {
        thisRef.selectedItems = [];
      }

      thisRef.uiService?.selectionInProgress.next(true);
      mappingFunction();
      document.getElementsByClassName(className)[0].parentElement.style.zIndex = '4';
    })
    .on('stop', () => {
      if (thisRef instanceof(MainContentComponent) && thisRef.uiService && thisRef.selectedItems && thisRef.selectedItems.length) {
        thisRef.uiService.showBottomPanel();
      }
      setTimeout(() => {
        thisRef.selectedItems = [];
      });

      thisRef.uiService?.selectionInProgress.next(false);
    });
}
